import { useEffect } from "react";
import { useConfig } from "../../providers/useConfig";
export const useTrustPilot = ({ ref, width, height, theme, }) => {
    const config = useConfig();
    const { isEnabledForTenant, businessUnitId } = config;
    useEffect(() => {
        if (window.Trustpilot && ref.current && isEnabledForTenant) {
            window.Trustpilot.loadFromElement(ref.current, true);
        }
    }, [ref, businessUnitId, isEnabledForTenant, width, height, theme]);
};
//# sourceMappingURL=useTrustPilot.js.map